function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const HashRouter = {
    getPath() {
        return location.hash
            .replace('#', '')
            .replace('/', '')
        ;
    },

    isRoute(route) {
        return HashRouter.getRoute() === route;
    },

    getRoute() {
        const path = HashRouter.getPath();
        return path.split("?")[0];
    },

    getParam(name) {
        return getParameterByName(name, HashRouter.getPath()) || null;
    },

    redirect(route, params = null) {
        let queryParams = '';

        if (params) {
            for (let [key, value] of Object.entries(params)) {
                if (queryParams.length === 0) {
                    queryParams += '?';
                } else {
                    queryParams += '&';
                }

                queryParams += `${key}=${value}`
            }
        }

        return location.hash = `/${route}${queryParams}`;
    }
};

export {
    HashRouter
}